import { CommonMutationCrumbs } from './breadcrumb';

export const UpdateParenthoodCrumbs = [
  ...CommonMutationCrumbs,
  {
    name: 'Aggiornamento Parentela',
    path: '/mutazioni/parentela/aggiornamento',
  },
];
